<template>
  <div :class="getItemTableContainerClass">
    <ItemTable
      ref="itemTable"
      :columns="columns"
      :inDetailsAsidePanel="true"
      :itemType="itemType"
      :keepFresh="false"
      :onMountedBeforeFetch="initializeCollection"
      :panelType="panelType"
      :selectionItemText="selectionItemText"
      :showBound="false"
      :showSearchForm="false"
    />
  </div>
</template>
<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import AdBridgeAgentActions from 'client/components/ItemTable/BodyComponents/AdBridgeAgentActions.vue';
import AdBridgeVersion from 'client/components/ItemTable/BodyComponents/AdBridgeVersion.vue';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';

const {
  ItemTableConsts,
  ItemTypeConsts,
  ItemTypeDisplayNames,
  StoreModelMap,
  StoreModuleMap,
} = Constants;
const { activeDirectory, adBridgeAgent } = ItemTypeConsts;
const { panelType } = ItemTableConsts;
const adBridgeAgentCollection = StoreModuleMap[adBridgeAgent];
const activeDirectoryModel = StoreModelMap[activeDirectory];

export default {
  name: 'AdBridgeAgentItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
  ],

  data() {
    return {
      columns: [
        {
          classNames: {
            body: [
              this.$style.adBridgeAgentHostNameColumn,
              this.$style.adBridgeAgentHostNameColumn,
              this.$style.tableCell,
              this.$style.tableBodyCell,
            ],
            heading: [
              this.$style.adBridgeAgentHostNameColumn,
              this.$style.adBridgeAgentHostNameColumn,
              this.$style.tableCell,
            ],
          },
          dataField: 'hostname',
          defaultValue: Constants.default.dataNotAvailable,
          headingText: 'Host Name',
          sortBy: 'hostname',
        },
        {
          bodyComponent: AdBridgeVersion,
          classNames: {
            body: [
              this.$style.tableCell,
              this.$style.tableBodyCell,
            ],
            heading: [this.$style.tableCell],
          },
          headingText: 'Agent Version',
        },
        {
          classNames: {
            body: [
              this.$style.tableCell,
              this.$style.tableBodyCell,
            ],
            heading: [this.$style.tableCell],
          },
          dataField: 'ipAddress',
          defaultValue: Constants.default.dataNotAvailable,
          headingText: 'Source IP',
        },
        {
          bodyComponent: AdBridgeAgentActions,
          classNames: {
            body: [this.$style.tableBodyCell],
          },
        },
      ],
      itemType: adBridgeAgent,
      panelType: panelType.directoryAsidePanel,
      selectionItemText: {
        label: 'selected',
        plural: `${ItemTypeDisplayNames[adBridgeAgent]}s`,
        singular: ItemTypeDisplayNames[adBridgeAgent],
      },
    };
  },

  computed: {
    ...mapState(activeDirectoryModel, {
      domain: state => state.item.domain,
      id: state => state.item.id,
    }),
  },

  methods: {
    ...mapActions(adBridgeAgentCollection, ['setAdBridgeDomain']),

    initializeCollection() {
      this.setAdBridgeDomain({ domain: this.domain, id: this.id });
    },
  },
};
</script>
<style module>
.tableCell {
  word-break: break-all;
}

.tableBodyCell {
  vertical-align: top;
}

/*
 * NOTE: A double classname is used here to trump ItemTable specificity introduced by using scoped
 * styles in that component. Anything to avoid the use of !important.
 */
.adBridgeAgentHostNameColumn.adBridgeAgentHostNameColumn {
  padding-left: 20px;
}
</style>
